import { render, staticRenderFns } from "./Magento.vue?vue&type=template&id=0c8c78f8"
import script from "./Magento.vue?vue&type=script&lang=ts"
export * from "./Magento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports